export const MARKER_RADIUS = 2;

// Tolerance threshold is used to avoid showing danger status on project burn and breakdown charts by removing the differences caused by rounding.
export const TOLERANCE_THRESHOLD = 5;

export const PROGRESS_DATA_DATE_FORMAT = 'yyyyMMdd';

export const DAY_INTERVAL_MS = 24 * 3600 * 1000;

export const NULL_VALUE_TEXT = 'N/A';

export const BurnUpChartLineNameTranslations = {
	Budget: 'project_burn_up_chart_budget',
	TotalCost: 'project_burn_chart_total_budgeted_cost',
	Actual: 'project_burn_up_chart_actual',
	UsedBudget: 'budget_burn_chart_used_budget',
	EarnedRevenue: 'budget_burn_chart_earned_revenue',
	Forecasted: 'project_burn_up_chart_forecasted',
	ForecastedEarnedRevenue: 'project_burn_up_chart_forecasted_earned_revenue',
	CostBurn: 'project_burn_up_chart_cost_burn',
	ActualCost: 'project_burn_up_chart_actual_cost',
	ForecastedCostBurn: 'project_burn_up_chart_forecasted_cost_burn',
	Planned: 'project_burn_up_chart_planned',
} as const;

export const BudgetChartLineNameTranslations = {
	Budget: 'project_budget_chart_budget',
	TotalCost: 'project_budget_chart_total_cost',
	Actual: 'project_budget_chart_actual',
	Forecasted: 'project_budget_chart_forecasted',
	CostBurn: 'project_budget_chart_actual_cost',
	CostForecasted: 'project_budget_chart_forecasted_cost',
	Planned: 'project_budget_chart_planned',
} as const;
